console.log("I'm `fs` modules");



/*****************
 ** WEBPACK FOOTER
 ** ./~/wpcom/~/fs/index.js
 ** module id = 573
 ** module chunks = 0
 **/